// extracted by mini-css-extract-plugin
export var cardHeader = "_g0-0";
export var reorderHandle = "_g0-3";
export var titleArea = "_g0-1";
export var titleAreaWithHandle = "_g0-2";